import Vue from 'vue';
import Account from '@/helper/AccountHelper.js';
import Locale from '@/helper/locale/locale.js';
//core
import { CallbackEvent } from '@/core/Utility/CallbackEvent.js'
//service
import { CustomHistoryConfigBuilder } from '../config/CustomHistoryConfig.js';
import CustomHistoryService from '../service/CustomHistoryService.js';
import { QuotaConfigBuilder } from '@/core/Custom/config/QuotaConfigModel.js';
import AIAService from '@/core/Custom/service/AIAService.js';

export function AIAHistoryController () {
    this.lbl = Locale.getLbl();
    //page
    this.isLoaded = false;
    this.isLoading = false;
    this.historyConfigBuilder = new CustomHistoryConfigBuilder();
    //list
    this.isUsed = false;
    this.isHaveItem = false;
    this.isHaveMore = false;
    this.list = [];
    //modal
    this.modalController = null;
    //callback event
    this.cbGetListSuccess = new CallbackEvent();
    this.cbApiError = new CallbackEvent();
    this.cbHistoryRedirect = new CallbackEvent();

    this.initialList = function (modalController) {
        this.modalController = modalController;
        let params = this.historyConfigBuilder
                        .setConfig('purchase_used') //default as used history
                        .create()
                        .getParams();

        this.getList(params);
    };

    //#region event
    this.changeMode = function (mode) {
        this.resetList();

        let params;
        if (mode == 'used') {
            this.isUsed = true;
            params = this.historyConfigBuilder
                .setConfig('purchase_used')
                .create()
                .getParams();
        } else {
            this.isUsed = false;
            params = this.historyConfigBuilder
                .setConfig('purchase_notuse')
                .create()
                .getParams();
        }

        this.getList(params);
    };
    this.getAll = function () {
        this.resetList();
        let params = this.historyConfigBuilder
                .setDate()
                .create()
                .getParams();

        this.getList(params);
    },
    this.changeMonth = function (year, month) {
        this.resetList();
        let params = this.historyConfigBuilder
                .setDate(year, month)
                .create()
                .getParams();

        this.getList(params);
    };
    this.resetList = function () {
        this.list = [];
        this.isHaveItem = false;
        this.isHavaMore = false;
        this.isLoaded = false;
        this.historyConfigBuilder.resetConfig();
    };
    //#endrion event

    //#region list
    this.getList = function (params, isSkipLoading) {
        if (!isSkipLoading) {
            if (this.showLoading()) return;
        }

        const token = Account.getToken();
        CustomHistoryService.apiHistory(token, params)
            .then(res => {
                for (var item of res) {
                    this.list.push(item);
                }

                this.historyConfigBuilder.addSkip();
                this.isHaveItem = (this.list.length > 0);
                this.isHaveMore = (res && res.length == 25);

                this.cbGetListSuccess.sendCallback();
            }).catch(err => {
                this.cbApiError.sendCallback({type: 'list', err: err});
            }).finally(() => {
                this.isLoaded = true;
                this.hideLoading();
            });
    };
    this.loadMore = function () {
        if (!this.isHaveMore) return;

        var params = this.historyConfigBuilder
                .create()
                .getParams();

        this.getList(params);
    };
    //#endregion list

    //#region redeem
    this.getHistoryInfo = async function (itemIndex, redeemKey) {
        if (this.isLoading) return;

        const item = this.list[itemIndex];
        if (item.type == Vue.CampaignType.Interface) {
            this.openInterfaceWeb(item);
            return;
        }

        if (this.showLoading()) return;

        // eslint-disable-next-line
        let isShowSerial = false;
        const useRes = await this.apiRedeemUse(item, redeemKey);
        if (!useRes) return;

        isShowSerial = true;
        this.list[itemIndex].setDataFromApiRedeem(useRes);

        const quotaRes = await this.apiQuota(itemIndex);
        if (!quotaRes) return;

        let serialItem = this.list[itemIndex];
        let privilegeGroup = 'default';
        let isAmbassadorCat = false;
        if (quotaRes && quotaRes.length > 0) {
            privilegeGroup = quotaRes[0].Group;
            isAmbassadorCat = (quotaRes[0].Tier.toLowerCase() == "ambassador" );
        }

        console.log(privilegeGroup);
        this.hideLoading();

        this.initialSerial(serialItem, privilegeGroup, isAmbassadorCat);

        const params = this.historyConfigBuilder
            .create()
            .getParams();

        this.getList(params, true);
    };
    this.apiRedeemUse = function (item, redeemKey) {
        return new Promise((resolve) => {
            const token = Account.getToken();
            CustomHistoryService.apiRedeemUse(token, redeemKey)
                .then(res => {
                    resolve(res);
                }).catch(err => {
                    this.hideLoading();
                    switch(err.response.data.error.id) {
                        case 1414:
                            this.initialSerial(item, 'default', false);
                            break;
                        default:
                            this.cbApiError.sendCallback({type: 'serial', err: err});
                            break;
                    }
                    resolve(null);
                });
        });
    };
    //#endregion redeem
    //#region interface
    this.openInterfaceWeb = function (history) {
        let token = Account.getTokenShuffle();
        let locale = Locale.getLocaleCode();
        let header = 'false';
        let theme = Vue.bzbsConfig.appname;
        let appName = Vue.bzbsConfig.appname;
        let returnUrl = encodeURIComponent(window.location.href);

        if (history.privilegeMessageFormat == 'link') {
            let url = history.privilegeMessage;

            url = url.replace('<campaign_id>', history.id);
            url = url.replace('<token>', token);
            url = url.replace('<serial>', history.serial);
            url = url.replace('<locale>', locale);

            url += '&return_url=' + returnUrl;

            window.location.replace(url);
            return;
        }

        if (history.website &&
            history.website.indexOf('/Landing/starbucks') >= 0) {
            Account.setCacheCustom('isfromhistorylanding', { page: 'interface' });
            window.location.href = history.website +
                '&token=' + token +
                '&appName=' + appName +
                '&locale=' + locale +
                '&RedeemKey=' + history.redeemKey +
                '&header=' + header +
                '&theme=' + theme +
                '&return_url=' + returnUrl; // ReturnUrl;
        } else if (history.website && history.website.indexOf('linesticker') >= 0) {
            Account.setCacheCustom('isfromhistorylanding', { page: 'other' });
            window.location.href = history.website
                + "&info2=" + history.info2
                + "&info3=" + history.info3
                + "&locale=" + locale
                + "&return_url=" + encodeURIComponent(window.location.href)
                + "&token=" + token
                + "&is_history=true";
        }
    };
    //#endregion interface

    //#region quota
    this.apiQuota = function (itemIndex) {
        return new Promise((resolve) => {
            const token = Account.getToken();
            const params = new QuotaConfigBuilder()
                            .setCatId(this.list[itemIndex].categoryId)
                            .create()
                            .getParams();

            AIAService.apiGetUserQuota(token, params)
                .then(res => {
                    resolve(res);
                }).catch(err => {
                    this.hideLoading();
                    this.cbApiError.sendCallback({type: 'serial', err: err});
                    resolve(null);
                });
        });
    };
    //#endregion quota

    //#region serial
    this.initialSerial = function (item, privilegeGroup, isAmbassadorCat) {
        this.modalController.serialModal
            .setCampaign(item)
            .setCampaignGroup(privilegeGroup)
            .setIsAmbassadorCat(isAmbassadorCat)
            .setTag('history')
            .show();

        this.modalController.serialModal
            .cbAction.onCallback(data => {
                if (data) {
                    switch (data.action) {
                        case 'redirect-aia':
                            this.cbHistoryRedirect.sendCallback({link: data.link});
                            break;
                        case 'expired':
                            // if (!this.isUsed) {
                            //     var itemIndex = null;
                            //     this.list.filter((val, index) => {
                            //         if (data.item.id == val.id
                            //             && data.item.itemNumber == val.itemNumber) {
                            //             itemIndex = index;
                            //         }
                            //     });

                            //     if (itemIndex != null) {
                            //         this.list.splice(itemIndex, 1);
                            //     }
                            // }
                            break;
                    }
                }
            });
    };
    //#endregion serial

    //#region loading
    this.showLoading = function () {
        if (this.isLoading) return true;
        this.isLoading = true;

        this.modalController.loadingModal.show();
    };
    this.hideLoading = function () {
        this.isLoading = false;
        this.modalController.loadingModal.hide();
    };
    //#endregion loading
}
